import { useState } from "react";

export const useConfirmationDeleteModal = () => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isConfirmationDeleteModalOpen, setIsConfirmationDeleteModalOpen] = useState(false);

  const handleCloseConfirmationModalOpen = () => {
    setIsConfirmationModalOpen(false);
  };

  const handleOpenConfirmationModalOpen = () => {
    setIsConfirmationModalOpen(true);
  };

  const handleCloseConfirmationDeleteModalOpen = () => {
    setIsConfirmationDeleteModalOpen(false);
  };

  const handleOpenConfirmationDeleteModalOpen = () => {
    setIsConfirmationDeleteModalOpen(true);
  };

  return {
    isConfirmationModalOpen,
    handleCloseConfirmationModalOpen,
    handleOpenConfirmationModalOpen,
    handleCloseConfirmationDeleteModalOpen,
    handleOpenConfirmationDeleteModalOpen,
    isConfirmationDeleteModalOpen,
  };
};
